import Header from "../../components/header/index.js";
import LeftMenu from "../../components/left-menu/index.js";
import Grid from '@mui/material/Grid';
import React, {Component} from 'react';
import axios from "axios";
import { useState, useEffect } from 'react';
import TextField from '@mui/material/TextField'; 
import Button from '@mui/material/Button';
import Post from "../../pages/ListKontrak/Post.jsx";
import {useNavigate} from "react-router-dom";
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ReceiptIcon from '@mui/icons-material/Receipt';
import LinearProgress from '@mui/material/LinearProgress';
import Box from '@mui/material/Box';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { endOfDecadeWithOptions } from "date-fns/fp";
import { editableInputTypes } from "@testing-library/user-event/dist/utils";
import { Select, MenuItem } from '@mui/material';
import { purple } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
import { Typography } from "@mui/material";
import { useSelector } from 'react-redux';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import InputAdornment from '@mui/material/InputAdornment';
export default function SalesReview(){
    const [address1,setAddress1] = useState("-")
    const nowstate = useSelector(state => state);
    const [sales,setSales]= useState(nowstate.user?.sales??"-")
    const [date,setDate]= useState(new Date())
    const [dateEnd,setDateEnd]= useState(new Date())

    const handleChangeAddress = (event) => {
        setAddress1(event.target.value)
        const alamatDicari = event.target.value
        axios.post(`${process.env.REACT_APP_BACKEND_URL}/confirm-address`,{
                alamatDicari
        }).then(response=>{
            console.log(response.data)
        });
    };

    const handleStartDate = (event) => {
        setDate(event.target.value)
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/salesReview?date=${event.target.value}&dateEnd=${dateEnd}&user=${sales}`,{
            
        }).then(resp => {
            setHitunganKontrak(resp.data.count)
        })
    };
    const [categorias, setCategorias] = useState([]);
    const getCategorias = async () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/addressOptions`,{
        }).then(response=>{
          setCategorias(response.data.pilihanAlamat);
      });
        //console.log(res);
      }

      

      const countKontrak = () => {
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/salesReview?date=${date}&dateEnd=${dateEnd}&user=${sales}`,{
            
        }).then(resp => {
            console.log(resp.data.count)
            setHitunganKontrak(resp.data.count)
        })
      }
      const [lokasi,setLokasi] = useState(["Jakarta Selatan", "Jakarta Barat", "Jakarta Pusat", "Jakarta Utara", "Jakarta Timur", "Tangerang", "Bekasi", "Bali", "Surabaya", "Depok", "Kalimantan"]);

      const [hitunganKontrak, setHitunganKontrak] = useState()
      const [iklan, setIklan]= useState("All")
      const [produkInterest,setProdukInterest]=useState("All")
      
    const [extend,setExtend]= useState("Semua")
    const [TipeKontrak,setTipeKontrak]= useState("All")
    useEffect(() => {
        const fetchData = async () => {
            await countKontrak();
        }
        fetchData();
    },[sales, address1, extend, TipeKontrak, date, dateEnd, iklan, produkInterest])
return(
    <Grid container>
    <Grid xs={6}>
    <Paper sx={{height: '100%', p:3}}>
        Sales:
        <Select  fullWidth value={sales} onChange={event => setSales(event.target.value)}><MenuItem value="-">Semua</MenuItem><MenuItem value="Adnan">Adnan</MenuItem><MenuItem value="Felly">Felly</MenuItem><MenuItem value="Diva">Diva</MenuItem></Select>
        <Grid container sx={{mt:5}}>
        <Grid xs={12} lg={6} >
        Dari: 
        <LocalizationProvider dateAdapter={AdapterDateFns}>

                                <MobileDatePicker 
                                    views={['year', 'month', 'day']}
                                    inputFormat="dd/MM/yyyy"
                                    value={date}
                                    onChange={(value)=>setDate(value)}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment >
                                                        <CalendarMonthIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    }
                                />

                    </LocalizationProvider>
                    </Grid>
                    <Grid  xs={12} lg={6}>
        Sampai:
        <LocalizationProvider dateAdapter={AdapterDateFns}>

                                <MobileDatePicker 
                                    views={['year', 'month', 'day']}
                                    inputFormat="dd/MM/yyyy"
                                    value={dateEnd}
                                    onChange={(value)=>setDateEnd(value)}
                                    renderInput={(params) => 
                                        <TextField 
                                            {...params} 
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment >
                                                        <CalendarMonthIcon />
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    }
                                />

                    </LocalizationProvider>
                    </Grid>
                    </Grid>
                    </Paper>
                    </Grid>
                    <Grid xs={1}></Grid>
        <Grid xs={12} container>
        <Grid xs={4}>
            <Paper sx={{height: '100%', p:3}}>
            <Typography variant="h3"><b>Ticket Handled</b></Typography>
            <Typography variant="h1">{hitunganKontrak?.InqActivity??0}</Typography>
            </Paper>
        </Grid>
        <Grid xs={4}>
            <Paper sx={{height: '100%', p:3}}>
            <Typography variant="h3"><b>Inquiry Solved : New Inquiry</b></Typography>
            <Typography variant="h1">{hitunganKontrak?.InqActivity??0} : {hitunganKontrak?.NewInq??0}</Typography>
            <Typography variant="h1">
                    {
                        // Calculate the percentage
                        // Use `NewInq` if it's greater than 0, otherwise use 0.1 to avoid division by zero
                        `${Math.round((hitunganKontrak?.InqActivity ?? 0) / (hitunganKontrak?.NewInq > 0 ? hitunganKontrak?.NewInq : 0.1) * 100)}%`
                    }
                    </Typography>

            </Paper>
        </Grid>
        <Grid xs={4}>
            <Paper sx={{height: '100%', p:3}}>
            <Typography variant="h3"><b>Still Unsolved Inquiry at End Date</b></Typography>
            <Typography variant="h1">{hitunganKontrak?.UnsolvedInq??0}</Typography>
            </Paper>
        </Grid>

</Grid>
<Grid xs={12} container>
        <Grid xs={4}>
            <Paper sx={{height: '100%', p:3}}>
            <Typography variant="h3"><b>Remind Solved</b></Typography>
            <Typography variant="h1">{hitunganKontrak?.SolvedActivity??0}</Typography>
            </Paper>
        </Grid>
        <Grid xs={4}>
            <Paper sx={{height: '100%', p:3}}>
            <Typography variant="h3"><b>Remind Solved: New Remind</b></Typography>
            <Typography variant="h1">{hitunganKontrak?.SolvedActivity??0} : {hitunganKontrak?.totalSum??0}</Typography>
            </Paper>
        </Grid>
        <Grid xs={4}>
            <Paper sx={{height: '100%', p:3}}>
            <Typography variant="h3"><b>Unsolved Remind</b></Typography>
            <Typography variant="h1">{hitunganKontrak?.UnsolvedReminderCount??0}</Typography>
            </Paper>
        </Grid>

</Grid>

    </Grid>
)
}